import { useNavigate } from 'react-router-dom';

import { useWishlist } from './store';
import { useAuth } from '../auth/store';

/**
 * Heart toggle (SRS §4.7). Wishlist is authenticated-only, so a guest click routes
 * to sign-in with a redirect back rather than silently failing.
 */
export function WishlistButton({
  productId,
  className = '',
}: {
  productId: string;
  className?: string;
}): JSX.Element {
  const navigate = useNavigate();
  const authed = useAuth((s) => s.status === 'authenticated');
  const active = useWishlist((s) => s.ids.has(productId));
  const add = useWishlist((s) => s.add);
  const remove = useWishlist((s) => s.remove);

  async function toggle(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    if (!authed) {
      navigate(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
      return;
    }
    if (active) await remove(productId);
    else await add(productId);
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={active ? 'Remove from wishlist' : 'Add to wishlist'}
      aria-pressed={active}
      className={`tap-target flex items-center justify-center rounded-full ${className}`}
    >
      <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden>
        <path
          d="M10 17.5l-1.1-1C4.9 12.9 2.5 10.7 2.5 8 2.5 5.9 4.1 4.3 6.2 4.3c1.2 0 2.3.5 3 1.4.7-.9 1.8-1.4 3-1.4 2.1 0 3.7 1.6 3.7 3.7 0 2.7-2.4 4.9-6.4 8.5z"
          fill={active ? 'var(--color-danger)' : 'none'}
          stroke={active ? 'var(--color-danger)' : 'var(--color-neutral)'}
          strokeWidth="1.4"
        />
      </svg>
    </button>
  );
}
